export enum Sizes {
    Small = 'sm',
    Medium = 'md',
    Large = 'lg',
}

export enum IndicatorTheme {
    Inverted = 'inverted',
    DarkMode = 'darkmode',
    Default = 'default',
}

export type LoadingIndicatorProps = {
    text?: string
    size?: string
    theme?: IndicatorTheme
    hideText?: boolean
    customMargins?: string
}
